import {WorkspaceUser} from '../../API';

import {DataSource, FilterSchema} from "./DataSource";

import {listWorkspaceUsersByUserId} from "./requests/listWorkspaceUsers";

import {onCreateWorkspaceUser, onDeleteWorkspaceUser, onUpdateWorkspaceUser} from "../../graphql/subscriptions";
import { UserDataSourceDeps } from "../../platform/services/types/DataSourceDependencies";


export class UserWorkspacesDataSource extends DataSource<WorkspaceUser, WorkspaceUser, UserDataSourceDeps> {
    readonly _modelName = 'WorkspaceUser' as const;
    readonly _subscriptionGQLs = {
        onCreate: onCreateWorkspaceUser,
        onUpdate: onUpdateWorkspaceUser,
        onDelete: onDeleteWorkspaceUser,
    } as const
    currentUserId: string;

    constructor(deps: UserDataSourceDeps, currentUserId: string) {
        super(deps);
        this.currentUserId = currentUserId;
    }

    get syncHash() {
        return this.currentUserId;
    }

    getFilterDefaultValues(): {} {
        return {
        }
    }

    getFilterSchema(): FilterSchema<WorkspaceUser> {
        return {
        }
    }

    loadGQLFetch() {
        return listWorkspaceUsersByUserId(
            this.deps.dataClientService,
            this.deps.authService,
            this.deps.userState.tenantId,
            this.currentUserId
        );
    };

    loadMoreGQLFetch(nextToken: string) {
        return listWorkspaceUsersByUserId(
            this.deps.dataClientService,
            this.deps.authService,
            this.deps.userState.tenantId,
            this.currentUserId, 
            nextToken
        );
    };

    getWsClient() {
        return this.deps.dataClientService.getWsClientForTable('workspaceUsers');
    };
}
